import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import PublicIcon from "@material-ui/icons/Public";
import styled from "styled-components";
import { useSnackbar } from "../../../../../app/contexts/snackbar.context";
import { useStudyPlan } from "../../../../../app/contexts/study.context";
import PrimaryButton from "../../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../../app/components/buttons/outlined";
import TextButton from "../../../../../app/components/buttons/text";
import { validateSeasonalVariations } from "../../../validations/validate.study.plan";

const BottomControls = ({
  errors,
  hasErrors,
  sequentialCohort,
  warnings,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, planId } = useParams();
  const { showSnackbar } = useSnackbar();
  const {
    studyPlan,
    savePlan,
    saveLoading,
    seqCohorts,
    unsavedChange,
    validateSequentialCohort,
    isSequential,
  } = useStudyPlan();

  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const handleDisabled = () => {
      const hasEmptyFields = (data) => {
        const fieldsToCheck = [
          "cohortName",
          "patients",
          "lagDays",
          "dtlDurationDays",
          "screeningDurationDays",
          "srcDurationDays",
        ];

        for (const field of fieldsToCheck) {
          if (
            data[field] === "" ||
            data[field] === null ||
            data[field] === undefined
          ) {
            return true;
          }
        }

        return false;
      };

      const isCohortEmpty = seqCohorts.some((cohort) => hasEmptyFields(cohort));

      if (sequentialCohort) {
        if (!saveLoading && hasErrors.length === 0 && !isCohortEmpty) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(!(!saveLoading && hasErrors.length === 0));
      }
    };

    handleDisabled();
  }, [seqCohorts, saveLoading, hasErrors, sequentialCohort]);

  const pushToNextPage = () => {
    const seqValid = isSequential
      ? validateSequentialCohort(location.pathname)
      : true;

    const { seasonalValid } = validateSeasonalVariations(studyPlan);
    if (Object.keys(warnings || {}).length !== 0) {
      showSnackbar(
        <ul>
          {Object.keys(warnings || {}).map((key) => {
            if (key !== "BUTTON_TYPE") return <li>{warnings[key]}</li>;
            return null;
          })}
        </ul>,
        "warning",
      );
    }
    if ((Object.keys(errors || {}).length !== 0 &&
        ["ALL", "NEXT2"].includes(errors.BUTTON_TYPE)) ||
      !seqValid ||
      !seasonalValid
    ) {
      showSnackbar(
        <ul>
          {Object.keys(errors || {}).map((key) => {
            if (key !== "BUTTON_TYPE") return <li>{errors[key]}</li>;
            return "";
          })}
          {!seqValid && <li>Sequential cohorts setup is not valid</li>}
          {!seasonalValid && (
            <li>Country enrollment seasonal variations are not valid</li>
          )}
        </ul>,
        "error",
      );
      return;
    }
    if (unsavedChange) {
      savePlan({
        isNew: false,
        redirect: () =>
          navigate(`/ctpo/study-plans/${id}/${planId}/review`),
      });
    } else {
      navigate(`/ctpo/study-plans/${id}/${planId}/review`);
    }
  };

  return (
    <div>
      <Container>
        <TextButton
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <PublicIcon />
          View Different Country
        </TextButton>
      </Container>
      <Container>
        <OutlinedButton
          onClick={() => navigate(`/ctpo/study-plans/${id}/${planId}`)}
          disabled={isDisabled}
        >
          Back
        </OutlinedButton>
        <PrimaryButton
          onClick={pushToNextPage}
          disabled={isDisabled}
        >
          {saveLoading ? (
            <CircularProgress
              style={{ color: "var(--White)" }}
              size="1em"
            />
          ) : (
            "Next Step"
          )}
        </PrimaryButton>
      </Container>
    </div>
  );
};

export default BottomControls;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  margin-top: 1em;
`;
